import { defineStore } from 'pinia';

export const useFlashStore = defineStore('flash', {
    state: () => ({
        messages: [],
    }),
    actions: {
        setMessages(messages) {
            this.messages = messages;
        },
        addMessage(message) {
            this.messages = [...this.messages, message];
        },
        addMessages(messages) {
            this.messages = [...this.messages, ...messages];
        },
        removeMessage(id) {
            this.messages = this.messages.filter(
                (message) => message.id !== id,
            );
        },
    },
});
